import { connect } from 'react-redux';
import InstallSelectionPage from '../components/InstallSelectionPage';
import { changeInstallProjectType, setUserWantsInstall, updateInstallPostalCode, changeCategorySelection, changeInstallDescription, changeDesiredDate } from '../actions/install';


const mapDispatchToProps = (dispatch, ownProps) => ({
    changeInstallProjectType: (e) => dispatch(changeInstallProjectType(e)),
    setInstallWanted: (e) => dispatch(setUserWantsInstall(e)),
    installPostaCodeChanged: (e) => dispatch(updateInstallPostalCode(e)),
    changeCategorySelection: (c, v) => dispatch(changeCategorySelection(c, v)),
    changeInstallDescription: (e) => dispatch(changeInstallDescription(e)),
    changeDesiredDate: (e) => dispatch(changeDesiredDate(e))
});

const mapStateToProps = (state, ownProps) => {
    return {
        installCategories: state.installProduct.categories,
        installWanted: state.installProduct.installWanted,
        installAvailable: state.installProduct.installAvailable,
        installDescription: state.installProduct.comment,
        estimatedDate: state.installProduct.estimatedDate,
        prevPage: ownProps.prevPage,
        nextPage: ownProps.nextPage
    };
};
const InstallProductPageContainer = connect(mapStateToProps,
    mapDispatchToProps
)(InstallSelectionPage);
export default InstallProductPageContainer;